
import React from 'react';
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { formatCurrency } from "@/lib/utils";
import { BridgeDataItem } from './types';
import { getIconComponent } from './utils/iconUtils';

interface RevenueSummaryCardProps {
  ytdRevenueItem: BridgeDataItem | undefined;
  totalBridgedItem: BridgeDataItem | undefined;
  targetRevenueItem: BridgeDataItem | undefined;
  revenueDifference: number;
  differencePercentage: number;
  isPositiveDifference: boolean;
}

export const RevenueSummaryCard: React.FC<RevenueSummaryCardProps> = ({
  ytdRevenueItem,
  totalBridgedItem,
  targetRevenueItem,
  revenueDifference,
  differencePercentage,
  isPositiveDifference
}) => {
  return (
    <div className="w-full lg:w-64 flex-shrink-0">
      <Card className="bg-secondary/80 p-4 border border-primary/20 p-4 p-3 h-full text-center">
        <h3 className="font-[16px] text-primary mb-3">Revenue Summary</h3>
        
        <div className="space-y-3">
          <div>
            <p className="text-[14px] text-primary-light">YTD Revenue:</p>
            <p className="text-lg font-bold">{ytdRevenueItem?.displayValue || formatCurrency(0)}</p>
          </div>
          
          <div>
            <p className="text-[14px] text-primary-light">Total Bridged Revenue:</p>
            <p className="text-lg font-bold">{totalBridgedItem?.displayValue || formatCurrency(0)}</p>
          </div>
          
          <div>
            <p className="text-[14px] text-primary-light">Target Revenue:</p>
            <p className="text-lg font-bold">{targetRevenueItem?.displayValue || formatCurrency(0)}</p>
          </div>
          
          <Separator className="my-2 bg-primary-light/20" />
          
          <div>
            <p className="font-[16px] text-primary mb-3">Revenue {isPositiveDifference ? 'Surplus' : 'Gap'}:</p>
            <div className="flex items-center px-[32px] py-[7px]">
              <p className={`text-lg font-bold ${isPositiveDifference ? 'text-green-500' : 'text-red-500'}`}>
                {formatCurrency(Math.abs(revenueDifference))}
              </p>
              <span className={`ml-2 text-sm ${isPositiveDifference ? 'text-green-500' : 'text-red-500'}`}>
                ({isPositiveDifference ? '+' : '-'}{Math.abs(differencePercentage).toFixed(2)}%)
              </span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
